import { useMainStore } from '@/stores/main'
import * as Server from '@/services/Server'
import * as Auth from '@/services/Auth'

/**
 * An automatic news has no dialog: the list it appears in is the only place it is read, so being shown
 * is being read. The news just shown are acknowledged on the server, but the list keeps rendering them
 * unread for this view — the acknowledged state is what the next load finds, so the first sight of a
 * news is unread and the second is not.
 *
 * A visitor has no read state (it is a fact of the account, see doc/news.md), so nothing is sent.
 *
 * @param {Array<object>} news the rows that were just rendered
 */
export function markSeenAutomatic(news) {
  if (!Auth.isAuthenticated()) {
    return
  }

  const ids = news.filter(item => item.rule && !item.read).map(item => item.id)

  if (!ids.length) {
    return
  }

  const store = useMainStore()

  // Fire and forget: a lost acknowledgement only means the news comes back unread next time.
  Server.put(store.apiPath.news_read_many, { news: ids }).catch(() => {})
}
